export default function ImagePlaceholder({ aspect = 'square', className = '' }) {
  const aspectClasses = {
    square: 'aspect-square',
    portrait: 'aspect-[3/4]',
    landscape: 'aspect-[4/3]',
  };

  return (
    <div
      className={`${aspectClasses[aspect]} bg-gradient-to-br from-[var(--background-secondary)] to-white border-2 border-dashed border-[var(--accent-gold)]/30 rounded-3xl flex items-center justify-center ${className}`}
      data-testid="image-placeholder"
    >
      <div className="text-center p-6">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-[var(--primary)]/20 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-[var(--accent-gold)]" 
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <p className="text-sm text-[var(--text-muted)] font-light">Photo coming soon</p>
      </div>
    </div>
  );
}